<script lang="ts" setup>
const documentId = inject("documentId") as any;

const isExporting = ref(false);

const props = defineProps({
  variant: {
    type: String as PropType<"outlined" | "text">,
    default: "text",
  },
  color: {
    type: String,
    default: "default",
  },
});

const exportToPDF = async () => {
  isExporting.value = true;
  await useExportLoadedDocument(documentId, ExportDocumentFormat.pdf);
  isExporting.value = false;
};
</script>

<template>
  <BaseOutlinedButton
    v-if="variant === 'outlined'"
    :color="color"
    @click.stop.prevent="exportToPDF"
    :show-spinner="isExporting"
  >
    <div class="flex flex-row items-center justify-start w-full">
      <icon name="grommet-icons:document-pdf" class="mr-2 text-[#FF0000]" />
      <span class="block"> Export to PDF </span>
    </div>
  </BaseOutlinedButton>
  <BaseTextButton
    v-else
    :color="color"
    @click.stop.prevent="exportToPDF"
    :show-spinner="isExporting"
  >
    <div class="flex flex-row items-center justify-start w-full">
      <icon name="grommet-icons:document-pdf" class="mr-2 text-[#FF0000]" />
      <span class="block"> Export to PDF </span>
    </div>
  </BaseTextButton>
</template>

<style scoped></style>
